import Route from '@ember/routing/route';

export default class TeamRoute extends Route {}
